import { FC } from 'react';
import { isNil } from 'lodash-es';
import { Box } from '@alf/uikit';
import GameName from '../GameName';
import { PragmaticLiveInfo } from '../PragmaticLiveInfo';
import GameTotalSeats from '../PragmaticLiveInstantInfo/GameTotalSeats';
import { IGameLiveDataSectionProps } from './types';

import styles from './index.module.css';

const GameLiveDataSection: FC<IGameLiveDataSectionProps> = ({
  isGameNameShown,
  gameName,
  gameLiveData,
  tags = [],
  showTags,
  isGameCardMinimised
}) => {
  return (
    <>
      {!isNil(gameLiveData?.seatsTaken) && (
        <GameTotalSeats
          tags={tags}
          showTags={showTags}
          totalSeatedPlayers={gameLiveData?.seatsTaken}
          isGameCardMinimised={isGameCardMinimised}
        />
      )}
      <Box
        className={styles.gameBottomInfoWrapper}
        direction="column"
        justify="end"
      >
        {isGameNameShown && (
          <GameName
            gameName={gameName}
            gameLiveData={gameLiveData}
            isGameCardMinimised={isGameCardMinimised}
          />
        )}
        {gameLiveData && !gameLiveData.isPragmaticInstantLiveData ? (
          <PragmaticLiveInfo
            pragmaticLiveData={gameLiveData}
            isGameCardMinimised={isGameCardMinimised}
          />
        ) : null}
      </Box>
    </>
  );
};

export default GameLiveDataSection;
